import type { SVGProps } from 'react';
const SvgGenerator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.857 5.143a.716.716 0 0 0-.714.714v14.286c0 .393.321.714.714.714h14.286a.716.716 0 0 0 .714-.714V5.857a.716.716 0 0 0-.714-.714zM3 5.857A2.86 2.86 0 0 1 5.857 3h14.286A2.86 2.86 0 0 1 23 5.857v14.286A2.86 2.86 0 0 1 20.143 23H5.857A2.86 2.86 0 0 1 3 20.143zM6.571 13c0-2.728 1.375-4.424 2.22-5.205.392-.366.923-.51 1.454-.51h5.505c.536 0 1.067.148 1.455.51.844.78 2.22 2.477 2.22 5.205s-1.376 4.42-2.22 5.205c-.392.366-.924.51-1.455.51h-5.504c-.536 0-1.067-.148-1.456-.51-.844-.78-2.219-2.477-2.219-5.205m5-2.5c0-.594-.477-1.071-1.071-1.071s-1.071.477-1.071 1.071v1.429c0 .593.477 1.071 1.071 1.071s1.071-.478 1.071-1.071zm5 0c0-.594-.477-1.071-1.071-1.071s-1.071.477-1.071 1.071v1.429c0 .593.477 1.071 1.071 1.071s1.071-.478 1.071-1.071zm-5 5.357v.714h2.858v-.714c0-.79-.639-1.428-1.429-1.428s-1.429.638-1.429 1.428"
    />
  </svg>
);
export default SvgGenerator;
